import { divide, every, filter, find, forEach, forIn, forOwn, get, includes, isArray, join, last, map, reject, round, toNumber } from 'lodash'
import router from '@app/app-routing'
import { isHzwApp } from './cookie'
import { Location } from 'vue-router'
import { CUSTOMCATEGORYTAGREGLIST } from '@constant/index'

export function setLoading(isShow = true) {
  const loadDom: HTMLElement | null = document.querySelector('#loadingComponent') as HTMLElement
  if (loadDom) {
    if (isShow) {
      loadDom.style.display = 'flex'
    } else {
      loadDom.style.display = 'none'
    }
  }
}

export function setBaiduTrack() {
  setTimeout(() => {
    var _hmt: any = _hmt || []
    ;(function() {
      //百度统计 每次执行前，先移除上次插入的代码
      document.getElementById('baidu_tj') && document.getElementById('baidu_tj')?.remove()
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?e14cf5c7ca235cccda52eb729d1fde8e'
      hm.id = 'baidu_tj'
      var s: any = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
  }, 0)
}

export function toLogin() {
  if (!isHzwApp()) {
    const REFER_URL = location.href
    location.href = `//passport.cekid.com/passport/login?referer=${encodeURIComponent(REFER_URL)}`
  } else {
    location.href = `${location.host}/login?cmd=login`
  }
}

export function getRouterQuery(query: any): string | undefined {
  if (isArray(query) && last(query)) {
    return last(query)
  } else {
    return query
  }
}

function supportWebp(): boolean {
  const ele = document.createElement('canvas')
  ele.width = 1
  ele.height = 1
  return ele.toDataURL && ele.toDataURL('image/webp').indexOf('data:image/webp') === 0
}

export function optimizeImage(value: string, width: number | undefined, height: number | undefined, viewType = '2') {
  const suffix = supportWebp() ? 'webp' : 'jpg'
  let imgUrl = `${value}?imageView2/${viewType}`
  imgUrl = imgUrl.replace(/^http(s?):/, '')
  if (width) {
    imgUrl += `/w/${width}`
  }
  if (height) {
    imgUrl += `/h/${height}`
  }
  imgUrl += `/q/80/format/${suffix}`
  return imgUrl
}

export function tailorImg(value: string, width: number | undefined, height: number | undefined) {
  const suffix = supportWebp() ? 'webp' : 'jpg'
  if (value && width && height) {
    return `${value}?imageMogr2/crop/${width}x${height}/q/80/format/${suffix}`
  } else {
    return value
  }
}

export function compressImage(value: string, width: number | undefined, height: number | undefined, isTailor = false) {
  let img = ''
  const isSupportWebp = supportWebp()
  if (value) {
    value = value.replace(/^http(s?):/, '')
    if (isSupportWebp && isTailor) {
      img = `${value}?imageMogr2/crop/${width}x${height}/q/80/format/webp`
    } else if (isSupportWebp && !isTailor) {
      img = optimizeImage(value, width, height)
    } else if (!isSupportWebp && isTailor) {
      img = `${value}?imageMogr2/crop/${width}x${height}/q/80/format/jpg`
    } else {
      img = optimizeImage(value, width, height)
    }
  }
  return img
}

export function avatar(value: string, width: number | undefined, height: number | undefined) {
  return value ? optimizeImage(value, width, height) : ''
}

export function toDemotion(value: string | number, rate = 100) {
  let num = toNumber(value)
  num = isNaN(num) ? 0 : num
  return round(divide(num, rate), 2)
}

export function mapCategorys(list: any[]) {
  return map(list, (item: any) => {
    const { categoryId: value, categoryName: text } = item
    return { value: `${value}`, text }
  })
}

export function routerPush(location: Location) {
  const currentRoute = router.currentRoute
  const query = currentRoute.query
  const hasSwt = query && query.swt
  const hasRefresh = query && query.refresh
  let toQuery = location.query
  if (hasSwt) {
    toQuery = { ...toQuery, swt: query.swt }
  }
  if (hasRefresh) {
    toQuery = { ...toQuery, refresh: query.refresh }
  }
  router.push({ ...location, query: toQuery })
}

export function divideNum(categoryId: string | number | undefined): number {
  if (categoryId) {
    return `${categoryId}`.length === 8 ? round(toNumber(categoryId) / 100) : toNumber(categoryId)
  } else {
    return 0
  }
}

export function getCustomTag(arr: any): any[] {
  const list: any[] = []
  const customObj: any = {}
  const objIndex: any = {
    '10111018': 1,
    '10111025': 3,
    '10111113': 5,
    '10111110': 6,
    '10111021': 8,
    '10111017': 10,
    '10111020': 11
  }
  forEach(arr, (item: any) => {
    const customTag = find(CUSTOMCATEGORYTAGREGLIST, (el: any) => {
      const regex = new RegExp(el.reg)
      return regex.test(item.value)
    })
    if (!!customTag) {
      const { id, text, index } = customTag
      const { value } = item
      let val = customObj[`${id}`]
      val = val ? val.value + `,${value}` : `${value}`
      customObj[`${id}`] = {
        value: val,
        text,
        index
      }
    } else {
      const { value, text } = item
      const index = objIndex[`${value}`]
      list.push({ value, text, index })
    }
  })

  forOwn(customObj, (item: any, key: any) => {
    list.unshift(item)
  })

  return list
}

export function mapToList(playLoad: any, def?: any) {
  const result: any = []
  if (def) result.push(def)
  Object.keys(playLoad).forEach(x => {
    result.push({
      ID: x,
      NAME: playLoad[x]
    })
  })
  return result
}
